import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown, faCaretUp } from "@fortawesome/free-solid-svg-icons";
import { GlobalContext } from "../../context/GlobalContext";
import Grid from "../Grid/Grid";

export default function TOC({ sections }) {
  const { isMobile } = React.useContext(GlobalContext);
  const [isCollapsed, setIsCollapsed] = React.useState(true);

  return (
    <div
      id="accordion"
      className={`${!isMobile && "article-text"} ${
        isMobile ? "text-left" : "text-justify"
      } text-light bg-dark`}
    >
      <div className="card bg-dark">
        <div
          className="card-header pointer"
          id="headingOne"
          data-toggle="collapse"
          data-target="#tableofcontent"
          aria-expanded="false"
          aria-controls="tableofcontent"
          aria-disabled="true"
          onClick={() => setIsCollapsed((prev) => !prev)}
        >
          <Grid className="text-muted d-flex align-items-center">
            <span className="col-10">Inhaltsverzeichnis</span>
            <span className="col-2 text-right">
              <FontAwesomeIcon
                icon={isCollapsed ? faCaretDown : faCaretUp}
                className="text-right"
              />
            </span>
          </Grid>
        </div>

        <div
          id="tableofcontent"
          className="collapse text-muted"
          aria-labelledby="headingOne"
          data-parent="#accordion"
        >
          <div className="card-body text-muted">
            <ul>
              {sections?.map((item) => (
                <li key={item.id}>
                  <a href={`#${item.id}`} className="text-muted">
                    {item.text}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
